var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u(
      [
        _vm.closable
          ? {
              key: "toolbar",
              fn: function fn() {
                return [_vm._v(" New Credit Card ")]
              },
              proxy: true
            }
          : null,
        {
          key: "body",
          fn: function fn() {
            return [
              _c("payment-gateway", {
                ref: "paymentGateway",
                attrs: {
                  compact: "",
                  "only-new": ""
                },
                on: {
                  card: _vm.listenCard
                }
              })
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function fn() {
            return [
              _vm.closable
                ? _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: _vm.close
                      }
                    },
                    [
                      _vm._v(" Cancel "),
                      _c(
                        "span",
                        {
                          staticClass: "visually-hidden text-lowercase"
                        },
                        [_vm._v(" button ")]
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "gg-btn",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.addCreditCard
                  }
                },
                [
                  _vm._v(" Add Credit Card "),
                  _c(
                    "span",
                    {
                      staticClass: "visually-hidden text-lowercase"
                    },
                    [_vm._v(" button ")]
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }